// Import Routes
import * as ROUTES from "../routes";

import GIFTCARDSTORE from '@/modules/giftcards/views/store'
import STOREGIFTCARD from '@/modules/giftcards/views/store/giftcard'
import GIFTCARDSTATS from '@/modules/giftcards/views/statistics'
import GIFTCARDTRANSACTIONS from '@/modules/giftcards/views/transactions'

const routes = [
    {
        path: ROUTES.STOREGIFTCARD,
        name: "StoreGiftCard",
        component: STOREGIFTCARD,
        meta: {
            title: "Gift Card",
            layout: "private",
            requiresAuth: true,
            nav: 'Giftcards',
            permissions: ['can_view_giftcards']
        }
    },
    {
        path: ROUTES.GIFTCARDSTORE,
        name: "Giftcards",
        component: GIFTCARDSTORE,
        meta: {
            title: "Gift Card Stores",
            layout: "private",
            requiresAuth: true,
            nav: 'Giftcards',
            permissions: ['can_view_giftcards']
        }
    },
    {
        path: ROUTES.GIFTCARDSTATS,
        name: "giftCardStats",
        component: GIFTCARDSTATS,
        meta: {
            title: "Gift Card Statistics",
            layout: "private",
            requiresAuth: true,
            nav: 'Giftcards',
            permissions: ['can_view_giftcards']
        }
    },
    {
        path: ROUTES.GIFTCARDTRANSACTIONS,
        name: "giftCardTransactions",
        component: GIFTCARDTRANSACTIONS,
        meta: {
            title: "Gift Card Transactions",
            layout: "private",
            requiresAuth: true,
            nav: 'Giftcards',
            permissions: ['can_view_giftcard_trades']
        }
    },
]

export default routes;